import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { cn } from '../../shared/cn';
type LoaderSize = 'xs' | 'sm' | 'base' | 'lg' | 'xl' | 'button';
type LoaderProps = {
  size?: LoaderSize;
  className?: string;
};
const sizeMap: Record<LoaderSize, string> = {
  xs: 'w-6 h-6',
  // 24px
  sm: 'w-7 h-7',
  // 28px
  base: 'w-8 h-8',
  // 32px
  lg: 'w-9 h-9',
  // 36px
  xl: 'w-10 h-10',
  // 40px
  button: 'w-5 h-5' // 20px
};
export const LoadingSpinner: FC<LoaderProps> = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "base" : t1;
  const t2 = sizeMap[size];
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("inline-block animate-spin rounded-full border-[3px]", "border-contentColorPrimary border-t-backgroundBlue", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="sr-only">Loading...</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <div role="status" className={t3}>{t4}</div>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};